export const userQuestKeys = {
  all: ["userQuests"] as const,
  userQuest: () => [...userQuestKeys.all, "detail"] as const,
  lists: () => [...userQuestKeys.all, "list"] as const,
  list: (filters: { userID?: number; offset?: number; limit?: number }) =>
    [...userQuestKeys.lists(), filters] as const,
  detail: (id: number) => [...userQuestKeys.userQuest(), id] as const,
};

export const userQuestMutationKeys = {
  create: ["createUserQuest"] as const,
  update: ["updateUserQuest"] as const,
  createOrUpdate: ["createOrUpdateUserQuest"] as const,
};
